import { ActionType, getType } from 'typesafe-actions';

import { logoutAsync, NetworkRequestState } from '@bolteu/redux-session';

export interface AuthRequestState {
  logoutRequestState: NetworkRequestState;
}

export type AuthRequestActions = ActionType<typeof logoutAsync>;

export const authRequestStateReducer = (
  state: AuthRequestState = { logoutRequestState: NetworkRequestState.unset },
  action: AuthRequestActions,
): AuthRequestState => {
  switch (action.type) {
    case getType(logoutAsync.request):
      return {
        ...state,
        logoutRequestState: NetworkRequestState.waiting,
      };
    case getType(logoutAsync.success):
      return {
        ...state,
        logoutRequestState: NetworkRequestState.success,
      };
    case getType(logoutAsync.failure):
      return {
        ...state,
        logoutRequestState: NetworkRequestState.failure,
      };
    default:
      return state;
  }
};
